import { useCallback } from "react";

export default function useCalculateStatistics() {
  const formatTime = useCallback((trackingTime) => {
    if (typeof trackingTime !== "number" || Number.isNaN(trackingTime)) return "00:00";
    const time = trackingTime / 60;
    let seconds;
    let minutes;
    if (time % 1 === 0) {
      seconds = 0;
      minutes = time;
    } else {
      seconds = Math.round((time - Math.trunc(time)) * 60);
      minutes = Math.trunc(time);
    }
    return (minutes < 10 ? "0" : "") + minutes + ":" + (seconds < 10 ? "0" : "") + seconds;
  }, []);

  const calculateStatistics = useCallback((options, times = [], groups = [], ages = [], genders = [], nationalities = [], tools = [], actions = []) => {
    const data = {};
    const safeTimes = Array.isArray(times) && times.length ? times : [0];

    data.totalMotions = times.length;
    const sumTimes = times.length ? times.reduce((a, b) => a + b, 0) : 0;
    data.averageTime = times.length ? formatTime(sumTimes / times.length) : formatTime(0);
    data.minTime = times.length ? formatTime(Math.min(...times)) : formatTime(0);
    data.maxTime = times.length ? formatTime(Math.max(...times)) : formatTime(0);

    const mostPopular = (arr) => {
      if (!Array.isArray(arr) || arr.length === 0) return null;
      const count = {};
      arr.forEach(x => { count[x] = (count[x] || 0) + 1; });
      return Object.keys(count).reduce((a, b) => (count[a] > count[b] ? a : b));
    };

    const popularGroupKey = mostPopular(groups);
    const popularGenderKey = mostPopular(genders);
    const popularAgeKey = mostPopular(ages);
    const popularNationalityKey = mostPopular(nationalities);
    const popularToolKey = mostPopular(tools);

    data.popularGroup = popularGroupKey !== null ? options?.groupOptions?.find(el => el.value === popularGroupKey)?.label : null;
    data.popularGender = popularGenderKey !== null ? options?.genderOptions?.find(el => el.value === popularGenderKey)?.label : null;
    data.popularAge = popularAgeKey !== null ? options?.ageOptions?.find(el => el.value === popularAgeKey)?.label : null;
    data.popularNationality = popularNationalityKey !== null ? options?.nationalityOptions?.find(el => el.value === popularNationalityKey)?.label : null;
    data.popularTool = popularToolKey !== null ? options?.toolsOptions?.find(el => el.value === popularToolKey)?.label : null;

    data.totalActions = Array.isArray(actions) ? actions.length : 0;
    data.averageActionsMap = data.totalActions > 0 && times.length > 0 ? (data.totalActions / times.length).toFixed(2) : 0;
    data.popularAction = data.totalActions > 0 ? options?.actions?.find(el => el.id == mostPopular(actions))?.title || "No actions" : "No actions";

    return data;
  }, [formatTime]);

  // añadida: función pura para contar acciones por opción
  const amountActionPerAction = useCallback((options, actions) => {
    if (!options?.actions) return [];
    return options.actions.map((opt) => ({
      ...opt,
      amount: (Array.isArray(actions) ? actions.filter((act) => act == opt.id).length : 0),
    }));
  }, []);

  return {
    formatTime,
    calculateStatistics,
    amountActionPerAction, // expuesto desde el hook
  };
}